import { isPlainObject, mapValues } from "lodash";
import { migrateSpacingToken, migrateColorToken } from "./v8-to-v10.esm.js";
function v8ResponsiveToPanda(v8Obj, mapValueFn) {
  const defaultVal = v8Obj.default;
  const lgLteVal = v8Obj.lg_lte;
  const smLteVal = v8Obj.sm_lte;
  const map = mapValueFn || ((v) => v);
  if (defaultVal && lgLteVal && smLteVal) {
    return {
      base: map(smLteVal),
      lg: map(lgLteVal),
      xl: map(defaultVal)
    };
  }
  if (defaultVal && lgLteVal) {
    return {
      base: map(lgLteVal),
      xl: map(defaultVal)
    };
  }
  if (defaultVal && smLteVal) {
    return {
      base: map(smLteVal),
      lg: map(defaultVal),
      xl: map(defaultVal)
    };
  }
  if (defaultVal) {
    return {
      base: map(defaultVal)
    };
  }
  const result = {};
  Object.entries(v8Obj).forEach(([k, v]) => {
    result[k] = map(v);
  });
  return result;
}
function resolveSpacing(value) {
  if (!value) return void 0;
  if (typeof value === "string") {
    return migrateSpacingToken(value);
  }
  if (typeof value === "object") {
    const keys = Object.keys(value);
    if (keys.length === 0) return void 0;
    if (keys.length === 1) {
      const val = value.default || Object.values(value)[0];
      return val ? migrateSpacingToken(val) : void 0;
    }
    const responsive = v8ResponsiveToPanda(value, (v) => v ? migrateSpacingToken(v) : void 0);
    return Object.keys(responsive).length > 0 ? responsive : void 0;
  }
  return void 0;
}
function resolveTextAlign(textAlign) {
  if (!textAlign) return void 0;
  if (typeof textAlign === "string") {
    return textAlign === "inherit" ? void 0 : textAlign;
  }
  if (typeof textAlign === "object") {
    const keys = Object.keys(textAlign);
    if (keys.length === 0) return void 0;
    if (keys.length === 1) {
      const val = textAlign.default || Object.values(textAlign)[0];
      return val === "inherit" ? void 0 : val;
    }
    const responsive = v8ResponsiveToPanda(textAlign);
    return Object.keys(responsive).length > 0 ? responsive : void 0;
  }
  return void 0;
}
function resolveColor(fontColor) {
  if (!fontColor) return void 0;
  const v10Color = migrateColorToken(fontColor);
  if (!v10Color || v10Color === "text.neutral") return void 0;
  return v10Color;
}
function migrateResponsiveValue(value, mapFn) {
  if (!value) return value;
  if (isPlainObject(value)) {
    return mapValues(value, (v) => isPlainObject(v) ? migrateResponsiveValue(v, mapFn) : mapFn(v));
  }
  return mapFn(value);
}
function migrateResponsiveSpacing(spacingObj, mapFn) {
  if (!spacingObj || !isPlainObject(spacingObj)) return spacingObj;
  return mapValues(spacingObj, (value) => migrateResponsiveValue(value, mapFn));
}
export {
  migrateResponsiveSpacing,
  migrateResponsiveValue,
  resolveColor,
  resolveSpacing,
  resolveTextAlign,
  v8ResponsiveToPanda
};
